// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","hoverOverTooltip":"_1EwxGeRN41NrXKdMB0e9y3","hoverOverTooltipInside":"_2HKTVXmkyJQBjlO3k1lBkT"};